let initSentryPromise = null

export const initSentry = () => {
  if (!process.env.SENTRY_DSN) {
    return Promise.resolve()
  }

  if (window.Sentry) {
    return Promise.resolve(window.Sentry)
  }

  if (!initSentryPromise) {
    initSentryPromise = import('@sentry/browser')
      .then(Sentry => {
        if (!window.Sentry) {
          Sentry.init({
            dsn: process.env.SENTRY_DSN,
            environment: process.env.RAILS_ENV,
            integrations: [new Sentry.BrowserTracing()],
            tracesSampleRate: 0.05,
            maxBreadcrumbs: 50,
            normalizeDepth: 3
          })
          window.Sentry = Sentry
        }

        return window.Sentry
      })
      .catch(() => {
        initSentryPromise = null
        window.Sentry = null
        return null
      })
  }

  return initSentryPromise
}

export const reportErrorToSentry = (error, context = null) => {
  if (!process.env.SENTRY_DSN) return

  const captureError = Sentry => {
    if (context) {
      Sentry.setContext('errorDetails', context)
    }
    Sentry.captureException(error)
  }

  if (window.Sentry) {
    captureError(window.Sentry)
  } else {
    initSentry().then(Sentry => {
      if (Sentry) {
        captureError(Sentry)
      }
    })
  }
}
